import {computed, defineComponent, PropType, reactive, watch} from "@vue/composition-api";
import {OtpType} from "./otp-types";
import {alertDialogue} from "@/functions/system-modal-functions";
import {i18n} from "@/utilities/vue-i18n";
import {SettingsContext} from "@/utilities/settings-context";
import TransitionSlide from "@/components/transition-slide/transition-slide";
import {Accounts, validatePassword} from "@noordigitalagency/accounts-ledigajobb";

export default defineComponent({
    components: {
        TransitionSlide
    },
    props: {
        email: String,
        otpType: Number as PropType<OtpType>,
        visible: Boolean
    },
    setup(props, context) {

        const accounts = new Accounts(SettingsContext.constants.accountsApiDomainName);

        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const model = reactive({

            otpCode: '',

            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            submittable: computed(() => model.otpCode.trim().length > 0 && /^[0-9]{6}$/.test(model.otpCode.trim()) && (props.otpType !== OtpType.ForgotPassword || settings.validPassword)),

            showResend: true,

            password: ''
        });

        const settings = reactive({

            passwordVisible: false,

            validPassword: computed(() => validatePassword(model.password, SettingsContext.get('signUp.passwordLength') as number))
        });

        watch(() => props.visible, (value, oldValue) => {

           if (value && !oldValue) {

               model.otpCode = '';
           }
        });

        const closeModal = () => {

            model.otpCode = '';

            context.emit('modal-close');
        }

        const confirmCode = async () => {

            const otpCode = model.otpCode;

            model.otpCode = '';

            context.emit('confirm', props.otpType !== OtpType.ForgotPassword ? {otpCode} : {otpCode, password: model.password});
        }

        const resendCode = async () => {

            await alertDialogue(i18n.t('components.otp-modal.title') as string, props.otpType === OtpType.ForgotPassword ? i18n.t('components.otp-modal.code-sent-reset', {email: props.email}) as string : i18n.t('components.otp-modal.code-sent', {email: props.email}) as string);

            model.showResend = false;

            if (props.otpType == OtpType.ForgotPassword) {

                await accounts.forgotPassword(props.email as string);
            }
            else {

                await accounts.activateAccount(props.email as string);
            }
        }

        return {
            model,
            closeModal,
            resendCode,
            confirmCode,
            OtpType,
            settings,
            passwordLength: SettingsContext.get('signUp.passwordLength') as number
        }
    }
});


